import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function BENEFITS() {
  return (
    <div
      className='md:mt-20 mt-10'
      id='benefits'
    >
      <div className='space-y-5'>
        <AnimateOnScroll animation='flipIn'>
          <div className='bg-black border border-[#FFFFFF1F] text-[#FF8A3D] text-center rounded-full w-36 py-2 px-5'>
            <h5>BENEFITS</h5>
          </div>
        </AnimateOnScroll>
        <AnimateOnScroll animation='flipIn'>
          <h1 className='md:text-5xl text-3xl font-medium '>
            Why ToolsAI? Read our Benefits
          </h1>
        </AnimateOnScroll>
      </div>
      <div className='grid lg:grid-cols-12 gap-10 mt-20'>
        <div className='lg:col-span-4 col-span-full'>
          <div className='flex md:justify-start justify-center banifit rounded-3xl'>
            <AnimateOnScroll animation='flipIn'>
              <img
                src='/images/banifits.png'
                alt='about'
                className='w-full md:h-[473px] h-[300px]  rounded-3xl '
              />
            </AnimateOnScroll>
          </div>
        </div>
        <div className='lg:col-span-8 col-span-full'>
          <div className='grid lg:grid-cols-2 grid-cols-1 gap-5'>
            <div className='lg:space-y-16 space-y-8'>
              <div className='flex gap-5'>
                <AnimateOnScroll animation='flipIn'>
                  <div className='w-32'>
                    <img
                      src='/images/fimilar-1.png'
                      alt='fimilar-1'
                      className='w-14 h-14 block'
                    />
                  </div>
                </AnimateOnScroll>
                <div className='space-y-2'>
                  <AnimateOnScroll animation='flipIn'>
                    <h3 className='md:text-xl text-base font-normal'>
                      Real-Time Alerts
                    </h3>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <p className='font-extralight'>
                      Stay ahead of the market with instant notifications on
                      volume changes and token burns.
                    </p>
                  </AnimateOnScroll>
                </div>
              </div>
              <div className='flex gap-5'>
                <AnimateOnScroll animation='flipIn'>
                  <div className='w-32'>
                    <img
                      src='/images/fimilar-2.png'
                      alt='fimilar-1'
                      className='w-14 h-14 block'
                    />
                  </div>
                </AnimateOnScroll>
                <div className='space-y-2'>
                  <AnimateOnScroll animation='flipIn'>
                    <h3 className='md:text-xl text-base font-normal'>
                      Community Confidence
                    </h3>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <p className='font-extralight'>
                      Use our AI-powered FUD detector to maintain a positive and
                      trustworthy community.
                    </p>
                  </AnimateOnScroll>
                </div>
              </div>
              <div className='flex gap-5'>
                <AnimateOnScroll animation='flipIn'>
                  <div className='w-32'>
                    <img
                      src='/images/fimilar-3.png'
                      alt='fimilar-1'
                      className='w-14 h-14 block'
                    />
                  </div>
                </AnimateOnScroll>
                <div className='space-y-2'>
                  <AnimateOnScroll animation='flipIn'>
                    <h3 className='md:text-xl text-base font-normal'>
                      User-Friendly
                    </h3>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <p className='font-extralight'>
                      Seamlessly integrated with Telegram for ease of use,
                      providing all essential tools in one place.
                    </p>
                  </AnimateOnScroll>
                </div>
              </div>
            </div>
            <div className='lg:space-y-16 space-y-8'>
              <div className='flex gap-5'>
                <AnimateOnScroll animation='flipIn'>
                  <div className='w-32'>
                    <img
                      src='/images/fimilar-4.png'
                      alt='fimilar-1'
                      className='w-14 h-14 block'
                    />
                  </div>
                </AnimateOnScroll>
                <div className='space-y-2'>
                  <AnimateOnScroll animation='flipIn'>
                    <h3 className='md:text-xl text-base font-normal'>
                      Enhanced Security
                    </h3>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <p className='font-extralight'>
                      Benefit from security scans and ratings, helping you make
                      safer investment choices.
                    </p>
                  </AnimateOnScroll>
                </div>
              </div>
              <div className='flex gap-5'>
                <AnimateOnScroll animation='flipIn'>
                  <div className='w-32'>
                    <img
                      src='/images/fimilar-5.png'
                      alt='fimilar-1'
                      className='w-14 h-14 block'
                    />
                  </div>
                </AnimateOnScroll>
                <div className='space-y-2'>
                  <AnimateOnScroll animation='flipIn'>
                    <h3 className='md:text-xl text-base font-normal'>
                      Comprehensive Analytics
                    </h3>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <p className='font-extralight'>
                      Access detailed token overviews and holder distributions
                      for better trading insights.
                    </p>
                  </AnimateOnScroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
